<section class="grid-fund">
    <div class="row">
        <div *ngFor="let item of renderFundObject" class="col-lg-3 grid-fund-responsive">
            <div *ngIf="item.cms_flag_recommend == 'y' && item.FundCode  !='' " class="card -fund recommend">
                <div class="card-body p-0">
                    <!-- <a id="{{item.fundId}}" class="favicon " rel="border-circle" (click)="favFundCard(item.fundId)">
            <i class="icon icon-heart"></i>
          </a> -->

                    <span *ngIf="item.cms_flag_recommend == 'y' " class="icon icon-star"></span>
                    <app-favorite-button [fundid]="item.fundId" [curr]="item.currency" [inCard]="true">
                    </app-favorite-button>
                    <a [routerLink]="['/fund/detail/',item.fundId,item.currency]" class="show-block">
                        <header>
                            <h1 class="h4 topic-title">{{item.fundCode}}</h1>
                            <div *ngIf="flag == 'th'; else elsefundName2">
                                <p class="name">{{item.fundNameTh}}</p>
                            </div>
                            <ng-template #elsefundName2>
                                <p class="name">{{item.fundNameEn | uppercase}}</p>
                            </ng-template>
                        </header>

                        <section class="card-value">
                            <ul class="list list-inline list-unstyled">
                                <li>
                                    <span class="group-value">
                                        <em>{{language.fundcardtitle1}}</em>
                                        <span class="number">{{fixFloatDigit(item.navPublish1)}}</span>
                                        <span class="{{isPositive(item.navDiff) ? 'up' : 'down'}}">
                                            <i class="fas fa-caret-{{caretStatus}}"></i>
                                            <span>{{fixFloatDigit(showOnlyValue(item.navDiff))}}
                                                <small>({{fixFloatDigit(showOnlyValue(item.navDiffPercent))}}%)</small>
                                            </span>
                                        </span>
                                    </span>
                                </li>
                                <li>
                                    <span class="group-price">
                                        <span>
                                            <em>{{language.fundcardtitle2}}</em>
                                            {{fixFloatDigit(item.navSub)}}
                                        </span>
                                        <span *ngIf="flag == 'th'; else elsefundcardtitle3_1">
                                            <em>{{language.fundcardtitle3}}</em>
                                            {{fixFloatDigit(item.navRed)}}
                                        </span>
                                        <ng-template #elsefundcardtitle3_1>
                                            <em>{{language.fundcardtitle3}} </em>
                                            <em>{{language.fundcardtitle3_1}}</em>
                                            <em>{{fixFloatDigit(item.navRed)}}</em>
                                        </ng-template>
                                    </span>
                                </li>
                            </ul>
                            <p class="total">
                                <span class="text">{{language.fundcardtitle4}}</span>
                                <span>{{setNumberFormat(item.netAsset) | number : '1.2-2'}}</span>
                            </p>
                            <p *ngIf="flag == 'th'" class="total" style="margin-top:-10px; height: 24px; ">
                                <span class="text">  </span>
                                <span></span>
                            </p>
                            <p *ngIf="flag == 'en'" class="total" style="margin-top:-10px; height: 31px; ">
                                <span class="text">  </span>
                                <span></span>
                            </p>
                        </section>
                        <footer>
                            <time *ngIf="flag == 'th'; else elsetime">{{language.fundcardtitle5}} {{changeFormatDate(item.fundPriceDate1)}}</time>
                            <ng-template #elsetime>
                                <time>{{language.fundcardtitle5}} {{item.fundPriceDate1 | date:'dd MMM yyyy'}}</time>
                            </ng-template>
                        </footer>
                    </a>
                </div>
            </div>

            <div *ngIf="item.cms_flag_recommend != 'y' && item.fundCode  !='' " class="card -fund">
                <div class="card-body p-0">
                    <!-- <a class="favicon" rel="border-circle" (click)="favFundCard()">
            <i class="icon icon-heart"></i>
          </a> -->
                    <span *ngIf="item.cms_flag_recommend == 'y' " class="icon icon-star"></span>
                    <app-favorite-button [fundid]="item.fundId" [curr]="item.currency" [inCard]="true">
                    </app-favorite-button>
                    <a [routerLink]="['/fund/detail/',item.fundId,item.currency]" class="show-block">
                        <header>
                            <h1 class="h4 topic-title">{{item.fundCode}}</h1>
                            <div *ngIf="flag == 'th'; else elsefundName1">
                                <p class="name">{{item.fundNameTh}}</p>
                            </div>
                            <ng-template #elsefundName1>
                                <p class="name">{{item.fundNameEn | uppercase}}</p>
                            </ng-template>
                        </header>

                        <section class="card-value">
                            <ul class="list list-inline list-unstyled">
                                <li>
                                    <span class="group-value">
                                        <em>{{language.fundcardtitle1}} </em>
                                        <span class="number">{{fixFloatDigit(item.navPublish1)}}</span>
                                        <span class="{{isPositive(item.navDiff) ? 'up' : 'down'}}">
                                            <i class="fas fa-caret-{{caretStatus}}"></i>
                                            <span>{{fixFloatDigit(showOnlyValue(item.navDiff))}}
                                                <small>({{fixFloatDigit(showOnlyValue(item.navDiffPercent))}}%)</small>
                                            </span>
                                        </span>
                                    </span>
                                </li>
                                <li>
                                    <span class="group-price"
                                        *ngIf="!(item.fundTypeId == '16' || item.fundTypeId == '15')">
                                        <span>
                                            <em>{{language.fundcardtitle2}}</em>
                                            <p *ngIf="item.navSub != 0; else isZeroNAVSub">{{fixFloatDigit(item.navSub)}}</p>
                                            <ng-template #isZeroNAVSub>
                                                <p>-</p>
                                            </ng-template>
                                        </span>
                                        <span *ngIf="flag == 'th'; else elsefundcardtitle3_2"> 
                                            <em>{{language.fundcardtitle3}}</em>
                                            <p *ngIf="item.navRed != 0; else isZeroNAVRed">{{fixFloatDigit(item.navRed)}}</p>
                                            <ng-template #isZeroNAVRed>
                                                <p>-</p>
                                            </ng-template>
                                        </span>
                                        <ng-template #elsefundcardtitle3_2>
                                            <em>{{language.fundcardtitle3}} </em>
                                            <em>{{language.fundcardtitle3_1}}</em>
                                            <em>{{fixFloatDigit(item.navRed)}}</em>
                                        </ng-template>
                                    </span>
                                </li>
                            </ul>
                            <p class="total">
                                <span class="text">{{language.fundcardtitle4}}</span>
                                <span>{{setNumberFormat(item.netAsset) | number : '1.2-2'}}</span>
                            </p>
                            <p class="total" style="margin-top:-10px"
                                *ngIf="item.fundTypeId == '16' || item.fundTypeId == '15'; else nottotal">
                                <span class="text">{{language.fundcardtitle6}}</span>
                                <span>{{setNumberFormat(item.totalassets) | number : '1.2-2'}}</span>
                            </p>
                            <ng-template #nottotal>
                                <p *ngIf="flag == 'th'" class="total" style="margin-top:-10px; height: 24px; ">
                                    <span class="text">  </span>
                                    <span></span>
                                </p>
                                <p *ngIf="flag == 'en'" class="total" style="margin-top:-10px; height: 31px; ">
                                    <span class="text">  </span>
                                    <span></span>
                                </p>
                            </ng-template>
                        </section>
                        <footer>
                            <time *ngIf="flag == 'th'; else elsetime2">{{language.fundcardtitle5}} {{changeFormatDate(item.fundPriceDate1)}}</time>
                            <ng-template #elsetime2>
                                <time>{{language.fundcardtitle5}} {{item.fundPriceDate1 | date:'dd MMM yyyy'}}</time>
                            </ng-template>
                        </footer>
                    </a>
                </div>
            </div>
        </div>
    </div>
</section>